import React, { useCallback, useEffect, useState } from 'react';
import { CardContent, CardHeader, Grid } from "@mui/material";
import { Breadcrumbs, TableCard } from '../../../../Components';
import { useDispatch, useSelector } from 'react-redux';
import { fetchArchiveRosters, MainTable } from '../index';
import Box from "@mui/material/Box";
import useDeepEqualSelector from '../../../../Hooks/useDeepEqualSelector';
import { TableActions } from './Menus/TableActions';

export const RosterArchive = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const filters = useSelector((store) => store.rosterArchive?.config?.filters);
    const pagination = useDeepEqualSelector((store) => store.rosterArchive.config.pagination);
    const fetchData = useCallback(async () => {
        setIsLoading(true);
        await fetchArchiveRosters({ 
            dispatch, 
            filters: { 
                ...filters, 
                ...pagination, 
                with: ['roster', 'roster.status'],
                only_roster_docs: true
            } 
        }).then((res) => {
            setIsLoading(false);
        });
    }, [filters, pagination, dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <Grid container spacing={3} elevated={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['ROSTER', 'ARCHIVE']} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <TableCard>
                    <CardHeader
                        title={"Roster Archive"}
                        action={<TableActions />}
                    />
                    <CardContent>
                        <MainTable isLoading={isLoading} setIsLoading={setIsLoading} />
                    </CardContent>
                </TableCard>
            </Grid>
        </Grid>
    );
};

